/**
 * BtnsLessons Component
 *
 * Features:
 * - Displays navigation buttons for previous and next lessons.
 * - Handles lesson navigation logic and URL construction.
 * - Uses Redux for course info and i18next for translations.
 * - Calls loadLesson prop when navigating lessons.
 * - Uses CSS modules for styling and Material-UI for UI.
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { getLinkLtik } from 'constants/LTIData';

import classes from './BtnsLessons.module.css';

const url = window.location.pathname.split('/');

const BtnsLessons = props => {
  const dataCourse = useSelector(state => state.courseInfo);
  const { t } = useTranslation(['lesson']);
  // State to store previous lesson ID
  const [prevLesson, setPrevLesson] = useState(null);
  // State to store next lesson ID
  const [nextLesson, setNextLesson] = useState(null);

  useEffect(() => {
    let prevFlag = false;
    let currentPrevLesson = null;
    let nextFlag = false;
    let currentNextLesson = null;
    let checkLesson = false;

    if (dataCourse.lessonsCourse.sizeSeparators >= 0) {
      if (dataCourse.lessonsCourse.separators.length > 0) {
        dataCourse.lessonsCourse.separators.map(separador => {
          separador.lessons.map(videosCount => {
            if (prevFlag == true) {
              return false;
            }
            currentPrevLesson = videosCount.idVideo;
            if (props.idLesson == currentPrevLesson) {
              prevFlag = true;
              return false;
            }
            setPrevLesson(videosCount.idVideo);
          });
        });

        dataCourse.lessonsCourse.separators.map(separador => {
          separador.lessons.map(videosCount => {
            if (nextFlag == true) {
              return false;
            }
            currentNextLesson = videosCount.idVideo;
            if (checkLesson == true) {
              setNextLesson(videosCount.idVideo);
              nextFlag = true;
              return false;
            }
            if (props.idLesson == currentNextLesson) {
              checkLesson = true;
            }
          });
        });
      } else {
        dataCourse.lessonsCourse.lessons.map(videosCount => {
          if (prevFlag == true) {
            return false;
          }
          currentPrevLesson = videosCount.idVideo;
          if (props.idLesson == currentPrevLesson) {
            prevFlag = true;
            return false;
          }
          setPrevLesson(videosCount.idVideo);
        });
        dataCourse.lessonsCourse.lessons.map(videosCount => {
          if (nextFlag == true) {
            return false;
          }
          currentNextLesson = videosCount.idVideo;
          if (checkLesson == true) {
            setNextLesson(videosCount.idVideo);
            nextFlag = true;
            return false;
          }
          if (props.idLesson == currentNextLesson) {
            checkLesson = true;
          }
        });
      }
    }
  }, [dataCourse.lessonsCourse]);

  // Calls the loadLesson prop function to trigger lesson load
  const changeLessonHandler = () => {
    props.loadLesson();
  };

  return (
    <div
      className={
        url[2] !== 'lp'
          ? classes.btnsLessonsContainer
          : classes.btnsHide
      }
    >
      {prevLesson !== null && (
        <>
          <Button
            onClick={changeLessonHandler}
            className={classes.button}
            component={Link}
            to={
              getLinkLtik()
                ? `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${
                    props.idCourse
                  }/${prevLesson}/?ltik=${getLinkLtik()}`
                : url[2] === 'a'
                ? `/a/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
                : url[2] === 'course'
                ? `/course/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
                : `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${prevLesson}`
            }
          >
            <ChevronLeftIcon />
            {t('previous')}
          </Button>
        </>
      )}
      {nextLesson !== null && (
        <>
          <Button
            onClick={changeLessonHandler}
            className={classes.button}
            component={Link}
            to={
              getLinkLtik()
                ? `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${
                    props.idCourse
                  }/${nextLesson}/?ltik=${getLinkLtik()}`
                : url[2] === 'a'
                ? `/a/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
                : url[2] === 'course'
                ? `/course/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
                : `/${
                    url[3] === 'aud' || url[2] === 'aud'
                      ? 'aud'
                      : url[3] === 'lesson' || url[2] === 'lesson'
                      ? 'lesson'
                      : 'f'
                  }/${props.idCourse}/${nextLesson}`
            }
          >
            {t('next')}
            <ChevronRightIcon />
          </Button>
        </>
      )}
    </div>
  );
};

BtnsLessons.propTypes = {
  /**
   * Data for the lesson
   */
  lessonData: PropTypes.object,
  /**
   * Lesson ID
   */
  idLesson: PropTypes.number,
  /**
   * Course ID
   */
  idCourse: PropTypes.number,
  /**
   * Function to load the lesson
   */
  loadLesson: PropTypes.func,
  /**
   * Format string
   */
  format: PropTypes.string
};

BtnsLessons.defaultProps = {
  lessonData: null,
  idLesson: null,
  idCourse: null,
  loadLesson: () => {},
  format: ''
};

export default BtnsLessons;
